var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex-1"},[_c('div',{staticStyle:{"width":"400px","height":"400px"},attrs:{"id":"arc"}})])}]

export { render, staticRenderFns }